export const en = {
  // Header
  home: "Home",
  pricing: "Pricing",
  features: "Features",
  faq: "FAQ",
  aiGenerator: "AI Generator",
  login: "Login",

  // Hero Section
  heroTitle: "Lunabrush AI",
  heroSubtitle: "Create stunning AI-generated images in seconds",
  worldFirstFree: "World's first unlimited free AI image generator",
  hundredPercentFree: "100% Free",
  poweredByFlux: "Powered by Flux19sv",
  noLoginRequired: "No Login Required",
  unlimitedGeneration: "Unlimited Generation",

  // AI Generator Section
  aiGeneratorTitle: "AI Image Generator",
  freeTrial: "Free Trial",
  describeImage: "Describe the image you want to generate...",
  generating: "Generating...",
  generatingPlease: "Generating, please wait......",
  generateImage: "Generate Image",

  // Gallery Section
  inspiration: "Get Inspired",
  inspirationDesc: "Explore amazing images generated by Lunabrush AI",
  viewMore: "View More",

  // Image Gallery
  futuristicCity: "Futuristic city night view, neon lights, cyberpunk style",
  forestCabin: "Mysterious cabin in the forest, surrounded by mist",
  spaceAstronaut: "Astronaut in space, nebula background",
  underwaterWorld: "Underwater world, coral reef, tropical fish",
  samurai: "Ancient Japanese samurai, cherry blossoms falling",
  mountainLake: "Mountain lake, sunrise, thin mist",
  spaceStation: "Sci-fi space station, planet background",
  magicForest: "Magic forest, glowing mushrooms, fairies",

  // Features
  featuresTitle: "Lunabrush Key Features",
  featuresDesc: "We continuously improve our AI models to provide you with the best image generation experience",
  highQuality: "High Quality Generation",
  highQualityDesc: "Generate stunning high-quality images using state-of-the-art AI models",
  fastResponse: "Fast Response",
  fastResponseDesc: "Get your AI-generated images in seconds, no waiting required",
  privacyProtection: "Privacy Protection",
  privacyProtectionDesc: "Your prompts and generated images are strictly protected",
  multipleStyles: "Multiple Styles",
  multipleStylesDesc: "Support various art styles, from realistic to anime",
  globalAvailable: "Globally Available",
  globalAvailableDesc: "Global server distribution ensures fast access and generation",
  apiAccess: "API Access",
  apiAccessDesc: "Enterprise-grade API access, easily integrate into your applications",

  // Stats
  statsTitle: "Trusted by Millions",
  statsDesc: "Join the global community and explore unlimited possibilities of AI image generation",
  registeredUsers: "Registered Users",
  dailyImages: "Daily Generated Images",
  averageRating: "Average Rating",
  millionPlus: "3M+",
  dailyCount: "1,530",
  rating: "4.9",

  // Testimonials
  testimonialsTitle: "What Users Say About Lunabrush AI",
  testimonialsDesc: "See how other users use Lunabrush AI to enhance their creative workflow",
  testimonial1Name: "Li Ming",
  testimonial1Role: "UI/UX Designer",
  testimonial1Content:
    "Lunabrush AI has completely transformed my design process. I can quickly generate concept images, saving a lot of time. The image quality is amazing!",
  testimonial2Name: "Wang Xiaohua",
  testimonial2Role: "Content Creator",
  testimonial2Content:
    "As a content creator, I need a lot of image materials every day. Lunabrush AI allows me to easily generate unique images, greatly improving my work efficiency.",
  testimonial3Name: "Zhang Wei",
  testimonial3Role: "Game Developer",
  testimonial3Content:
    "Lunabrush AI's image generation capability is very powerful, especially in creating game concept art. It helps our team quickly iterate ideas and accelerate the development process.",

  // FAQ
  faqTitle: "Frequently Asked Questions",
  faqDesc: "Find answers to common questions about our service",
  faq1Question: "Why use Lunabrush AI?",
  faq1Answer:
    "Lunabrush AI provides state-of-the-art AI image generation technology, allowing users to create beautiful images with just one click! Our models are specially trained to understand complex prompts and generate high-quality, detailed images. Additionally, we offer a variety of style options to meet different creative needs.",
  faq2Question: "Can I upgrade or cancel my subscription?",
  faq2Answer:
    "You can upgrade or downgrade your subscription plan at any time in your account settings. If you decide to cancel your subscription, you can easily do so on the account page, and we won't charge any additional fees.",
  faq3Question: "Can I get a refund?",
  faq3Answer: "No, we do not offer refund services.",
  faq4Question: "Do you save my prompts?",
  faq4Answer:
    "Yes, we save your prompts to improve our service. However, we take user privacy very seriously, and all stored prompts are anonymized and not associated with your personal information. If you are a paid user, you can choose to enable privacy mode, so your prompts will not be saved.",
  faq5Question: "If I subscribe to Ultimate, can I get higher quality images?",
  faq5Answer:
    "Yes! Ultimate subscription users can access our high-resolution (HD) image generation feature, which produces images with higher resolution and richer details. In addition, Ultimate users can also use our professional models, which are specially optimized to generate higher quality images.",
  faq6Question: "Will I still see ads if I subscribe?",
  faq6Answer:
    "After subscribing to any paid plan, you will not see any ads. We want to provide the best distraction-free experience for paid users, allowing you to focus on creation.",
  faq7Question: "Can I request user support?",
  faq7Answer: "Yes! You can contact us via email at support@lunabrush.ai for technical support and assistance.",
  faq8Question: "What is enterprise-level service?",
  faq8Answer:
    "If you need special solutions, we offer enterprise-level services, including dedicated support, higher usage quotas, API access, etc. Please contact sales@lunabrush.ai for details.",

  // Footer
  footerDesc: "Lunabrush AI is a leader in FLUX-LLM technology, focusing on AI image generation",
  allRightsReserved: "Lunabrush AI. All rights reserved",
  tools: "Tools",
  support: "Support",
  imageGallery: "Image Gallery",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",

  // Login Page
  welcomeTitle: "Welcome to Lunabrush AI",
  welcomeDesc: "Choose your login method to start creating amazing AI images",
  googleLogin: "Login with Google",
  githubLogin: "Login with GitHub",
  loggingIn: "Logging in...",
  loginTerms: "By logging in, you agree to our",
  and: "and",

  // Create Page
  createImage: "Create Image",
  createDesc: "Create stunning images with Lunabrush AI",
  basic: "Basic",
  advanced: "Advanced",
  prompt: "Prompt",
  promptPlaceholder: "Describe the image you want to generate...",
  model: "Model",
  selectModel: "Select Model",
  negativePrompt: "Negative Prompt",
  negativePromptPlaceholder: "What you don't want to appear in the image...",
  aspectRatio: "Aspect Ratio",
  selectAspectRatio: "Select Aspect Ratio",
  promptStrength: "Prompt Strength",
  highQualityGeneration: "High Quality Generation (takes longer)",
  preview: "Preview",
  imageWillAppear: "Your image will appear here",
  enterPrompt: "Enter a prompt and click generate",
  download: "Download",
  share: "Share",
  bookmark: "Bookmark",

  // Gallery Page
  galleryTitle: "Image Gallery",
  galleryDesc: "Explore amazing images generated by Lunabrush AI",
  searchPrompts: "Search prompts...",
  sortBy: "Sort by",
  latest: "Latest",
  popular: "Popular",
  trending: "Trending",
  style: "Style",
  allStyles: "All Styles",
  realistic: "Realistic",
  anime: "Anime",
  digitalArt: "Digital Art",
  fantasy: "Fantasy",
  loadMore: "Load More",

  // Pricing
  choosePlan: "Choose Your Plan",
  pricingDesc: "Choose faster generation speed and advanced features with Lunabrush AI premium",
  monthly: "Monthly",
  yearly: "Yearly",
  saveTwoMonths: "Save 2 months",
  advanced: "Advanced",
  personalUse: "Perfect for personal use",
  unlimitedGeneration: "Unlimited image generation",
  fastGeneration: "Fast generation (5 images/min)",
  noAds: "No ads",
  noWatermark: "No watermark",
  upgradeToAdvanced: "Upgrade to Advanced",
  ultimate: "Ultimate",
  mostPopular: "Most Popular",
  professionalCreators: "Perfect for professional creators",
  ultraFastGeneration: "Ultra-fast generation",
  hdResolution: "Advanced HD resolution",
  privateGeneration: "Private generation",
  advancedModels: "10+ advanced model support",
  earlyAccess: "Early access to new features",
  upgradeToUltimate: "Upgrade to Ultimate",
  enterprise: "Enterprise",
  custom: "Custom",
  teamsAndEnterprises: "Perfect for teams and enterprises",
  customSolutions: "Custom solutions",
  dedicatedSupport: "Dedicated support",
  teamIntegration: "Team tool integration",
  highVolume: "High volume",
  contactUs: "Contact Us",

  // Style Options
  style: "Style",
  noStyle: "No Style",
  digitalArt: "Digital Art",
  cyberpunk: "Cyberpunk",
  lineArt: "Line Art",
  photography: "Photography",
  film: "Film",
  origami: "Origami",
  model3d: "3D Model",
  anime: "Anime",
  fantasyArt: "Fantasy Art",
  lowPoly: "Low Poly",
  cinematic: "Cinematic",
  enhanced: "Enhanced",
  comicBook: "Comic Book",
  isometric: "Isometric",
  clay: "Clay",

  // Color Tone Options
  colorTone: "Color Tone",
  noColor: "No Color",
  warmTones: "Warm Tones",
  coolTones: "Cool Tones",
  softColors: "Soft Colors",
  vibrantColors: "Vibrant Colors",
  pastelColors: "Pastel Colors",
  blackAndWhite: "Black & White",

  // Lighting Options
  lighting: "Lighting",
  noLighting: "No Lighting",
  dramatic: "Dramatic",
  dimLighting: "Dim Lighting",
  studio: "Studio",
  lowLight: "Low Light",
  goldenHour: "Golden Hour",
  backlight: "Backlight",
  volumetricLight: "Volumetric Light",
  tyndallEffect: "Tyndall Effect",
  sunlight: "Sunlight",
  rimLight: "Rim Light",

  // Composition Options
  composition: "Composition",
  noComposition: "No Composition",
  blurredBackground: "Blurred Background",
  closeUp: "Close Up",
  wideAngle: "Wide Angle",
  shallowDepthOfField: "Shallow Depth of Field",
  bottomUpShot: "Bottom Up Shot",
  topDownShot: "Top Down Shot",
  macroPhotography: "Macro Photography",

  // 通用
  close: "Close",
} as const
